import { render, staticRenderFns } from "./TodaysTopAuction.vue?vue&type=template&id=91690d5a&"
import script from "./TodaysTopAuction.vue?vue&type=script&lang=js&"
export * from "./TodaysTopAuction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports